module.exports = __webpack_public_path__ + "static/018-slideshow-31edee2e985d32bdfe07072d276560dd.jpg";